import { render, staticRenderFns } from "./brigada-prevencion-capacitacion-ver.vue?vue&type=template&id=3c8dc70d&"
import script from "./brigada-prevencion-capacitacion-ver.vue?vue&type=script&lang=js&"
export * from "./brigada-prevencion-capacitacion-ver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports